module.exports = __webpack_public_path__ + "fonts/poppins-regular-webfont.274d313e.woff";